import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAtom } from "@effect-atom/atom-react";
import { App } from "../../components/App";
import { loadFiddleAtom } from "../../atoms";

export const Route = createFileRoute("/$shortId/$revision")({
  component: FiddlePage,
});

function FiddlePage() {
  const { shortId, revision } = Route.useParams();
  const [, loadFiddle] = useAtom(loadFiddleAtom);

  useEffect(() => {
    loadFiddle({
      id: shortId,
      revision: parseInt(revision, 10),
    });
  }, [shortId, revision, loadFiddle]);

  return <App />;
}
